import React from "react";
import HeaderLp from "../LandingPage/HeaderLp";
import ButtonScrollTop from "../LandingPage/ButtonScrollTop";
import FooterLandingpage from "../LandingPage/FooterLandingpage/FooterLandingpage";
import { useGetPolicyQuery } from "../../utils/api/condition/condition.api";
import { AlertInfo } from "../common/Alert";
import { ConditionSkeleton } from "./CguPage";
import { createMarkup } from "../../utils/utils";

function PolicyPage() {
    const { data = [], isLoading } = useGetPolicyQuery();
  return (
    <div className="contact-us-component overflow-x-hidden">
      <HeaderLp />
      {/* <BreadCrumb title="Nous contacter" pageName="Nous contacter" /> */}
      <section
        className="contact-us-section gradient-background h-auto"
        style={{ minHeight: "100vh" }}
      >
        <div className="row row-contact-us mb-5">
          <h1 className="title-login-page pb-5 text-uppercase">
            Politiques de Confidentialité
          </h1>
          <div className="container-form-login cgu-content">
            {!!isLoading && <ConditionSkeleton />}
            {!isLoading &&
              (!data?.length ? (
                <div>
                  <AlertInfo message="Aucun contenu trouvé" />
                </div>
              ) : (
                <>
                  <p
                    className="mb-3"
                    dangerouslySetInnerHTML={createMarkup(data[0]?.text)}
                  />
                </>
              ))}
          </div>
        </div>
      </section>

      <ButtonScrollTop />
      <FooterLandingpage />
    </div>
  );
}

export default PolicyPage;
